import { useState, useEffect } from 'react';
import PixelCoffee from './PixelCoffee';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false); // Close mobile menu after navigation
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'glass py-4' : 'bg-transparent py-6'
      }`}
    >
      <nav className="container-custom px-6 md:px-12 flex items-center justify-between">
        <div className="text-xl md:text-2xl font-heading font-bold">
          <span className="gradient-text">D.OSTROW</span>
        </div>

        <ul className="hidden md:flex items-center gap-8">
          <li>
            <button
              onClick={() => scrollToSection('about')}
              className="text-text-secondary hover:text-quantum-blue transition-colors duration-200"
            >
              About
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection('projects')}
              className="text-text-secondary hover:text-quantum-green transition-colors duration-200"
            >
              Projects
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection('experience')}
              className="text-text-secondary hover:text-quantum-purple transition-colors duration-200"
            >
              Experience
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection('recommendations')}
              className="text-text-secondary hover:text-neural-orange transition-colors duration-200"
            >
              Reviews
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection('writing')}
              className="text-text-secondary hover:text-quantum-purple transition-colors duration-200"
            >
              Writing
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection('support')}
              className="flex items-center gap-1.5 text-text-secondary hover:text-neural-orange transition-colors duration-200"
            >
              <PixelCoffee size="sm" />
              <span>Support</span>
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection('contact')}
              className="btn-primary text-sm"
            >
              Contact
            </button>
          </li>
        </ul>

        {/* Mobile menu button */}
        <div className="md:hidden">
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="text-quantum-blue transition-colors hover:text-quantum-green"
            aria-label="Toggle menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {mobileMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>
      </nav>

      {/* Mobile menu dropdown */}
      <div
        className={`md:hidden transition-all duration-300 ease-in-out overflow-hidden ${
          mobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="glass border-t border-glass-border">
          <ul className="px-6 py-4 space-y-4">
            <li>
              <button
                onClick={() => scrollToSection('about')}
                className="block w-full text-left text-text-secondary hover:text-quantum-blue transition-colors duration-200 py-2"
              >
                About
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('projects')}
                className="block w-full text-left text-text-secondary hover:text-quantum-green transition-colors duration-200 py-2"
              >
                Projects
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('experience')}
                className="block w-full text-left text-text-secondary hover:text-quantum-purple transition-colors duration-200 py-2"
              >
                Experience
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('recommendations')}
                className="block w-full text-left text-text-secondary hover:text-neural-orange transition-colors duration-200 py-2"
              >
                Reviews
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('writing')}
                className="block w-full text-left text-text-secondary hover:text-quantum-purple transition-colors duration-200 py-2"
              >
                Writing
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('support')}
                className="flex items-center gap-2 w-full text-left text-text-secondary hover:text-neural-orange transition-colors duration-200 py-2"
              >
                <PixelCoffee size="sm" />
                <span>Support</span>
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('contact')}
                className="w-full btn-primary text-sm"
              >
                Contact
              </button>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
